const SetupState = {
    LOADING: 'loading',
    LOADED: 'loaded',
    ERROR_FETCHING: 'error_fetching'
};

export default SetupState;
